/* eslint-disable no-use-before-define */
import React, { useState, useContext } from 'react';
import { matchPath } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Box,
  List,
  makeStyles,
  Avatar,
  Typography,
  Button,
} from '@material-ui/core';
import { Dialog } from '@material-ui/core';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import { useHistory } from 'react-router-dom';
import ConfirmationDialog from 'src/component/ConfirmationDialog';
import { FaWallet, FaSignOutAlt, FaKey,FaEye } from 'react-icons/fa';
import { AuthContext } from 'src/context/Auth';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ModifyTwoFA from 'src/component/ModifyTwoFA';
const sections = [
  {
    title: 'Wallet',
    href: '/my-wallet',
    icon: FaWallet,
  },
  {
    title: 'Change Password',
    href: '/change-password',
    icon: FaEye,
  },
  {
    title: '2FA',
    icon: FaKey,
  },
  {
    title: 'Logout',
    href: '/dashboard',
    icon: FaSignOutAlt,
  },
];

function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    position: 'absolute',
    right: 0,
    top: 30,
    width: 280,
    // background: theme.palette.primary.main,
  },
  avatar: {
    cursor: 'pointer',
    width: 50,
    height: 50,
  },
  avatarBig: {
    cursor: 'pointer',
    width: 150,
    height: 150,
  },
  socialIcon: {
    cursor: 'pointer',
    marginRight: 5,
  },
}));

const NavBar = () => {
  const classes = useStyles();
  const [rightBar, setRightBar] = useState(false);
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const auth = useContext(AuthContext);
  const [openModify2FA, setOpenModify2FA] = useState(false);
  const confirmationHandler = () => {
    auth.userLogIn(false, null);
    history.push('/login');
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      {open && (
        <ConfirmationDialog
          open={open}
          handleClose={() => setOpen(false)}
          title={'Logout'}
          desc={'Do you want to Logout'}
          confirmationHandler={confirmationHandler}
        />
      )}
      {openModify2FA && (
        <ModifyTwoFA
          open={openModify2FA}
          handleClose={() => setOpenModify2FA(false)}
        />
        // alert('Invalid Credentials')
      )}

      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box>
          <Typography variant="h6" align="left">
            {auth.userData.firstName} {auth.userData.lastName}
          </Typography>
          <Typography variant="caption" align="left">
            {auth.userData.email}
          </Typography>
        </Box>
        <div style={{ borderBottom: '1px solid white', height: 10 }}></div>
        <Box py={2}>
          {sections.map((section, i) => {
            const Icon = section.icon;
            return (
              <Button
                fullWidth
                style={{ justifyContent: 'left', textTransform: 'capitalize' }}
                key={i}
                onClick={() => {
                  section.title === 'Logout'
                    ? setOpen(true)
                    : section.title === '2FA'
                    ? setOpenModify2FA(true)
                    : history.push(section.href);
                }}
              >
                <Icon color="#00e0b0" /> &nbsp;&nbsp;{section.title}
              </Button>
            );
          })}
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Avatar
        src="/images/user.png"
        className={classes.avatar}
        onClick={() => {
          setRightBar(!rightBar);
        }}
      />
      <Dialog
        classes={{ paper: classes.desktopDrawer }}
        open={rightBar}
        onClose={() => {
          setRightBar(false);
        }}
      >
        {content}
      </Dialog>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
